function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 450 450",
    style: {
      enableBackground: "new 0 0 450 450"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 227.259,
    y: 350.314,
    style: {
      fill: "#FFAE01"
    },
    width: 122.813,
    height: 15.48
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M234.889,362.358c-0.174,0-0.316-0.141-0.316-0.316v-7.978c0-0.175,0.142-0.316,0.316-0.316 c0.174,0,0.316,0.141,0.316,0.316v7.978C235.206,362.217,235.064,362.358,234.889,362.358z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M243.144,362.358c-0.174,0-0.316-0.141-0.316-0.316v-7.978c0-0.175,0.142-0.316,0.316-0.316 c0.174,0,0.316,0.141,0.316,0.316v7.978C243.46,362.217,243.318,362.358,243.144,362.358z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M251.398,362.358c-0.174,0-0.316-0.141-0.316-0.316v-7.978c0-0.175,0.142-0.316,0.316-0.316 c0.174,0,0.316,0.141,0.316,0.316v7.978C251.714,362.217,251.573,362.358,251.398,362.358z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M259.653,362.358c-0.174,0-0.316-0.141-0.316-0.316v-7.978c0-0.175,0.142-0.316,0.316-0.316 c0.175,0,0.316,0.141,0.316,0.316v7.978C259.969,362.217,259.827,362.358,259.653,362.358z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M267.907,362.358c-0.175,0-0.316-0.141-0.316-0.316v-7.978c0-0.175,0.142-0.316,0.316-0.316 c0.175,0,0.316,0.141,0.316,0.316v7.978C268.224,362.217,268.082,362.358,267.907,362.358z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M276.162,362.358c-0.175,0-0.316-0.141-0.316-0.316v-7.978c0-0.175,0.142-0.316,0.316-0.316 c0.175,0,0.316,0.141,0.316,0.316v7.978C276.478,362.217,276.337,362.358,276.162,362.358z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M284.416,362.358c-0.175,0-0.316-0.141-0.316-0.316v-7.978c0-0.175,0.142-0.316,0.316-0.316 c0.175,0,0.316,0.141,0.316,0.316v7.978C284.733,362.217,284.591,362.358,284.416,362.358z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M292.671,362.358c-0.175,0-0.316-0.141-0.316-0.316v-7.978c0-0.175,0.141-0.316,0.316-0.316 c0.175,0,0.316,0.141,0.316,0.316v7.978C292.987,362.217,292.846,362.358,292.671,362.358z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M300.926,362.358c-0.175,0-0.316-0.141-0.316-0.316v-7.978c0-0.175,0.141-0.316,0.316-0.316 c0.175,0,0.316,0.141,0.316,0.316v7.978C301.242,362.217,301.1,362.358,300.926,362.358z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M309.18,362.358c-0.175,0-0.316-0.141-0.316-0.316v-7.978c0-0.175,0.141-0.316,0.316-0.316 c0.175,0,0.316,0.141,0.316,0.316v7.978C309.496,362.217,309.355,362.358,309.18,362.358z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M317.435,362.358c-0.175,0-0.316-0.141-0.316-0.316v-7.978c0-0.175,0.141-0.316,0.316-0.316 c0.175,0,0.316,0.141,0.316,0.316v7.978C317.751,362.217,317.61,362.358,317.435,362.358z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M325.689,362.358c-0.175,0-0.316-0.141-0.316-0.316v-7.978c0-0.175,0.141-0.316,0.316-0.316 c0.175,0,0.316,0.141,0.316,0.316v7.978C326.005,362.217,325.864,362.358,325.689,362.358z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M333.944,362.358c-0.175,0-0.316-0.141-0.316-0.316v-7.978c0-0.175,0.141-0.316,0.316-0.316 c0.175,0,0.316,0.141,0.316,0.316v7.978C334.26,362.217,334.119,362.358,333.944,362.358z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M342.198,362.358c-0.176,0-0.316-0.141-0.316-0.316v-7.978c0-0.175,0.141-0.316,0.316-0.316 c0.175,0,0.316,0.141,0.316,0.316v7.978C342.514,362.217,342.374,362.358,342.198,362.358z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 217.247,
    y: 319.354,
    style: {
      fill: "#FFAE01"
    },
    width: 122.813,
    height: 15.48
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M224.877,331.4c-0.174,0-0.316-0.141-0.316-0.316v-7.978c0-0.175,0.142-0.316,0.316-0.316 c0.174,0,0.316,0.141,0.316,0.316v7.978C225.193,331.259,225.051,331.4,224.877,331.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M233.131,331.4c-0.174,0-0.316-0.141-0.316-0.316v-7.978c0-0.175,0.142-0.316,0.316-0.316 c0.174,0,0.316,0.141,0.316,0.316v7.978C233.448,331.259,233.305,331.4,233.131,331.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M241.386,331.4c-0.174,0-0.316-0.141-0.316-0.316v-7.978c0-0.175,0.142-0.316,0.316-0.316 s0.316,0.141,0.316,0.316v7.978C241.702,331.259,241.56,331.4,241.386,331.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M249.641,331.4c-0.174,0-0.316-0.141-0.316-0.316v-7.978c0-0.175,0.142-0.316,0.316-0.316 c0.174,0,0.316,0.141,0.316,0.316v7.978C249.957,331.259,249.815,331.4,249.641,331.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M257.895,331.4c-0.174,0-0.316-0.141-0.316-0.316v-7.978c0-0.175,0.142-0.316,0.316-0.316 s0.316,0.141,0.316,0.316v7.978C258.211,331.259,258.07,331.4,257.895,331.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M266.15,331.4c-0.174,0-0.316-0.141-0.316-0.316v-7.978c0-0.175,0.142-0.316,0.316-0.316 c0.175,0,0.316,0.141,0.316,0.316v7.978C266.466,331.259,266.324,331.4,266.15,331.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M274.404,331.4c-0.175,0-0.316-0.141-0.316-0.316v-7.978c0-0.175,0.142-0.316,0.316-0.316 c0.175,0,0.316,0.141,0.316,0.316v7.978C274.721,331.259,274.579,331.4,274.404,331.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M282.659,331.4c-0.175,0-0.316-0.141-0.316-0.316v-7.978c0-0.175,0.142-0.316,0.316-0.316 c0.175,0,0.316,0.141,0.316,0.316v7.978C282.975,331.259,282.834,331.4,282.659,331.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M290.914,331.4c-0.175,0-0.316-0.141-0.316-0.316v-7.978c0-0.175,0.141-0.316,0.316-0.316 c0.175,0,0.316,0.141,0.316,0.316v7.978C291.23,331.259,291.089,331.4,290.914,331.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M299.168,331.4c-0.175,0-0.316-0.141-0.316-0.316v-7.978c0-0.175,0.141-0.316,0.316-0.316 c0.175,0,0.316,0.141,0.316,0.316v7.978C299.484,331.259,299.343,331.4,299.168,331.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M307.423,331.4c-0.175,0-0.316-0.141-0.316-0.316v-7.978c0-0.175,0.141-0.316,0.316-0.316 c0.175,0,0.316,0.141,0.316,0.316v7.978C307.739,331.259,307.598,331.4,307.423,331.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M315.677,331.4c-0.175,0-0.316-0.141-0.316-0.316v-7.978c0-0.175,0.141-0.316,0.316-0.316 c0.175,0,0.316,0.141,0.316,0.316v7.978C315.994,331.259,315.853,331.4,315.677,331.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M323.932,331.4c-0.175,0-0.316-0.141-0.316-0.316v-7.978c0-0.175,0.141-0.316,0.316-0.316 c0.176,0,0.316,0.141,0.316,0.316v7.978C324.248,331.259,324.108,331.4,323.932,331.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M332.187,331.4c-0.175,0-0.316-0.141-0.316-0.316v-7.978c0-0.175,0.141-0.316,0.316-0.316 c0.176,0,0.316,0.141,0.316,0.316v7.978C332.503,331.259,332.362,331.4,332.187,331.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 211.11,
    y: 272.914,
    style: {
      fill: "#FFAE01"
    },
    width: 122.812,
    height: 15.48
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M218.741,284.961c-0.174,0-0.316-0.141-0.316-0.316v-7.98c0-0.175,0.142-0.316,0.316-0.316 c0.174,0,0.316,0.141,0.316,0.316v7.98C219.057,284.82,218.915,284.961,218.741,284.961z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M226.995,284.961c-0.174,0-0.316-0.141-0.316-0.316v-7.98c0-0.175,0.142-0.316,0.316-0.316 c0.174,0,0.316,0.141,0.316,0.316v7.98C227.311,284.82,227.17,284.961,226.995,284.961z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M235.25,284.961c-0.174,0-0.316-0.141-0.316-0.316v-7.98c0-0.175,0.142-0.316,0.316-0.316 c0.174,0,0.316,0.141,0.316,0.316v7.98C235.566,284.82,235.424,284.961,235.25,284.961z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M243.504,284.961c-0.174,0-0.316-0.141-0.316-0.316v-7.98c0-0.175,0.142-0.316,0.316-0.316 c0.175,0,0.316,0.141,0.316,0.316v7.98C243.821,284.82,243.679,284.961,243.504,284.961z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M251.759,284.961c-0.174,0-0.316-0.141-0.316-0.316v-7.98c0-0.175,0.142-0.316,0.316-0.316 c0.175,0,0.316,0.141,0.316,0.316v7.98C252.075,284.82,251.934,284.961,251.759,284.961z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M260.013,284.961c-0.175,0-0.316-0.141-0.316-0.316v-7.98c0-0.175,0.142-0.316,0.316-0.316 c0.175,0,0.316,0.141,0.316,0.316v7.98C260.33,284.82,260.188,284.961,260.013,284.961z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M268.268,284.961c-0.175,0-0.316-0.141-0.316-0.316v-7.98c0-0.175,0.142-0.316,0.316-0.316 c0.175,0,0.316,0.141,0.316,0.316v7.98C268.584,284.82,268.443,284.961,268.268,284.961z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M276.522,284.961c-0.175,0-0.316-0.141-0.316-0.316v-7.98c0-0.175,0.141-0.316,0.316-0.316 c0.175,0,0.316,0.141,0.316,0.316v7.98C276.839,284.82,276.697,284.961,276.522,284.961z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M284.777,284.961c-0.175,0-0.316-0.141-0.316-0.316v-7.98c0-0.175,0.141-0.316,0.316-0.316 c0.175,0,0.316,0.141,0.316,0.316v7.98C285.093,284.82,284.952,284.961,284.777,284.961z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M293.031,284.961c-0.175,0-0.316-0.141-0.316-0.316v-7.98c0-0.175,0.141-0.316,0.316-0.316 c0.175,0,0.316,0.141,0.316,0.316v7.98C293.348,284.82,293.207,284.961,293.031,284.961z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M301.286,284.961c-0.175,0-0.316-0.141-0.316-0.316v-7.98c0-0.175,0.141-0.316,0.316-0.316 c0.175,0,0.316,0.141,0.316,0.316v7.98C301.602,284.82,301.461,284.961,301.286,284.961z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M309.541,284.961c-0.175,0-0.316-0.141-0.316-0.316v-7.98c0-0.175,0.141-0.316,0.316-0.316 c0.175,0,0.316,0.141,0.316,0.316v7.98C309.857,284.82,309.716,284.961,309.541,284.961z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M317.795,284.961c-0.175,0-0.316-0.141-0.316-0.316v-7.98c0-0.175,0.141-0.316,0.316-0.316 c0.175,0,0.316,0.141,0.316,0.316v7.98C318.111,284.82,317.97,284.961,317.795,284.961z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M326.05,284.961c-0.176,0-0.316-0.141-0.316-0.316v-7.98c0-0.175,0.141-0.316,0.316-0.316 c0.175,0,0.316,0.141,0.316,0.316v7.98C326.366,284.82,326.225,284.961,326.05,284.961z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 204.651,
    y: 257.435,
    style: {
      fill: "#FFAE01"
    },
    width: 122.812,
    height: 15.48
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M212.281,269.479c-0.174,0-0.316-0.141-0.316-0.316v-7.978c0-0.176,0.142-0.316,0.316-0.316 c0.174,0,0.316,0.141,0.316,0.316v7.978C212.597,269.338,212.455,269.479,212.281,269.479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M220.536,269.479c-0.174,0-0.316-0.141-0.316-0.316v-7.978c0-0.176,0.142-0.316,0.316-0.316 c0.174,0,0.316,0.141,0.316,0.316v7.978C220.852,269.338,220.71,269.479,220.536,269.479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M228.79,269.479c-0.174,0-0.316-0.141-0.316-0.316v-7.978c0-0.176,0.142-0.316,0.316-0.316 c0.174,0,0.316,0.141,0.316,0.316v7.978C229.107,269.338,228.965,269.479,228.79,269.479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M237.045,269.479c-0.175,0-0.316-0.141-0.316-0.316v-7.978c0-0.176,0.142-0.316,0.316-0.316 c0.174,0,0.316,0.141,0.316,0.316v7.978C237.361,269.338,237.219,269.479,237.045,269.479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M245.3,269.479c-0.175,0-0.316-0.141-0.316-0.316v-7.978c0-0.176,0.142-0.316,0.316-0.316 c0.174,0,0.316,0.141,0.316,0.316v7.978C245.616,269.338,245.474,269.479,245.3,269.479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M253.554,269.479c-0.175,0-0.316-0.141-0.316-0.316v-7.978c0-0.176,0.141-0.316,0.316-0.316 s0.316,0.141,0.316,0.316v7.978C253.87,269.338,253.729,269.479,253.554,269.479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M261.809,269.479c-0.175,0-0.316-0.141-0.316-0.316v-7.978c0-0.176,0.141-0.316,0.316-0.316 s0.316,0.141,0.316,0.316v7.978C262.125,269.338,261.984,269.479,261.809,269.479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M270.063,269.479c-0.175,0-0.316-0.141-0.316-0.316v-7.978c0-0.176,0.141-0.316,0.316-0.316 c0.175,0,0.316,0.141,0.316,0.316v7.978C270.38,269.338,270.238,269.479,270.063,269.479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M278.318,269.479c-0.175,0-0.316-0.141-0.316-0.316v-7.978c0-0.176,0.141-0.316,0.316-0.316 c0.175,0,0.316,0.141,0.316,0.316v7.978C278.634,269.338,278.493,269.479,278.318,269.479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M286.573,269.479c-0.175,0-0.316-0.141-0.316-0.316v-7.978c0-0.176,0.141-0.316,0.316-0.316 c0.175,0,0.316,0.141,0.316,0.316v7.978C286.889,269.338,286.748,269.479,286.573,269.479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M294.827,269.479c-0.175,0-0.316-0.141-0.316-0.316v-7.978c0-0.176,0.141-0.316,0.316-0.316 c0.175,0,0.316,0.141,0.316,0.316v7.978C295.143,269.338,295.003,269.479,294.827,269.479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M303.082,269.479c-0.175,0-0.316-0.141-0.316-0.316v-7.978c0-0.176,0.141-0.316,0.316-0.316 c0.175,0,0.316,0.141,0.316,0.316v7.978C303.398,269.338,303.257,269.479,303.082,269.479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M311.336,269.479c-0.175,0-0.316-0.141-0.316-0.316v-7.978c0-0.176,0.141-0.316,0.316-0.316 c0.176,0,0.316,0.141,0.316,0.316v7.978C311.653,269.338,311.512,269.479,311.336,269.479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M319.591,269.479c-0.175,0-0.316-0.141-0.316-0.316v-7.978c0-0.176,0.141-0.316,0.316-0.316 c0.176,0,0.316,0.141,0.316,0.316v7.978C319.907,269.338,319.767,269.479,319.591,269.479z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 229.036,
    y: 288.394,
    style: {
      fill: "#FFAE01"
    },
    width: 122.812,
    height: 15.48
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M236.666,300.44c-0.174,0-0.316-0.141-0.316-0.316v-7.978c0-0.176,0.142-0.316,0.316-0.316 c0.174,0,0.316,0.141,0.316,0.316v7.978C236.982,300.299,236.84,300.44,236.666,300.44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M244.92,300.44c-0.174,0-0.316-0.141-0.316-0.316v-7.978c0-0.176,0.142-0.316,0.316-0.316 c0.174,0,0.316,0.141,0.316,0.316v7.978C245.237,300.299,245.094,300.44,244.92,300.44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M253.175,300.44c-0.174,0-0.316-0.141-0.316-0.316v-7.978c0-0.176,0.142-0.316,0.316-0.316 c0.174,0,0.316,0.141,0.316,0.316v7.978C253.491,300.299,253.349,300.44,253.175,300.44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M261.429,300.44c-0.174,0-0.316-0.141-0.316-0.316v-7.978c0-0.176,0.142-0.316,0.316-0.316 c0.174,0,0.316,0.141,0.316,0.316v7.978C261.746,300.299,261.604,300.44,261.429,300.44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M269.684,300.44c-0.175,0-0.316-0.141-0.316-0.316v-7.978c0-0.176,0.142-0.316,0.316-0.316 c0.175,0,0.316,0.141,0.316,0.316v7.978C270,300.299,269.858,300.44,269.684,300.44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M277.938,300.44c-0.175,0-0.316-0.141-0.316-0.316v-7.978c0-0.176,0.142-0.316,0.316-0.316 c0.175,0,0.316,0.141,0.316,0.316v7.978C278.255,300.299,278.113,300.44,277.938,300.44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M286.193,300.44c-0.175,0-0.316-0.141-0.316-0.316v-7.978c0-0.176,0.142-0.316,0.316-0.316 c0.175,0,0.316,0.141,0.316,0.316v7.978C286.509,300.299,286.368,300.44,286.193,300.44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M294.447,300.44c-0.175,0-0.316-0.141-0.316-0.316v-7.978c0-0.176,0.141-0.316,0.316-0.316 c0.175,0,0.316,0.141,0.316,0.316v7.978C294.764,300.299,294.622,300.44,294.447,300.44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M302.702,300.44c-0.175,0-0.316-0.141-0.316-0.316v-7.978c0-0.176,0.141-0.316,0.316-0.316 c0.175,0,0.316,0.141,0.316,0.316v7.978C303.018,300.299,302.877,300.44,302.702,300.44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M310.956,300.44c-0.175,0-0.316-0.141-0.316-0.316v-7.978c0-0.176,0.141-0.316,0.316-0.316 c0.175,0,0.316,0.141,0.316,0.316v7.978C311.273,300.299,311.132,300.44,310.956,300.44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M319.211,300.44c-0.175,0-0.316-0.141-0.316-0.316v-7.978c0-0.176,0.141-0.316,0.316-0.316 c0.175,0,0.316,0.141,0.316,0.316v7.978C319.527,300.299,319.386,300.44,319.211,300.44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M327.465,300.44c-0.175,0-0.316-0.141-0.316-0.316v-7.978c0-0.176,0.141-0.316,0.316-0.316 c0.175,0,0.316,0.141,0.316,0.316v7.978C327.782,300.299,327.641,300.44,327.465,300.44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M335.72,300.44c-0.175,0-0.316-0.141-0.316-0.316v-7.978c0-0.176,0.141-0.316,0.316-0.316 c0.175,0,0.316,0.141,0.316,0.316v7.978C336.036,300.299,335.895,300.44,335.72,300.44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M343.974,300.44c-0.175,0-0.316-0.141-0.316-0.316v-7.978c0-0.176,0.141-0.316,0.316-0.316 c0.176,0,0.316,0.141,0.316,0.316v7.978C344.291,300.299,344.15,300.44,343.974,300.44z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 221.284,
    y: 303.874,
    style: {
      fill: "#FFAE01"
    },
    width: 122.813,
    height: 15.48
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M228.914,315.919c-0.174,0-0.316-0.141-0.316-0.316v-7.978c0-0.175,0.142-0.316,0.316-0.316 c0.174,0,0.316,0.141,0.316,0.316v7.978C229.23,315.778,229.088,315.919,228.914,315.919z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M237.169,315.919c-0.174,0-0.316-0.141-0.316-0.316v-7.978c0-0.175,0.142-0.316,0.316-0.316 c0.174,0,0.316,0.141,0.316,0.316v7.978C237.485,315.778,237.343,315.919,237.169,315.919z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M245.423,315.919c-0.174,0-0.316-0.141-0.316-0.316v-7.978c0-0.175,0.142-0.316,0.316-0.316 c0.174,0,0.316,0.141,0.316,0.316v7.978C245.739,315.778,245.598,315.919,245.423,315.919z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M253.678,315.919c-0.174,0-0.316-0.141-0.316-0.316v-7.978c0-0.175,0.142-0.316,0.316-0.316 c0.175,0,0.316,0.141,0.316,0.316v7.978C253.994,315.778,253.852,315.919,253.678,315.919z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M261.932,315.919c-0.174,0-0.316-0.141-0.316-0.316v-7.978c0-0.175,0.142-0.316,0.316-0.316 c0.175,0,0.316,0.141,0.316,0.316v7.978C262.249,315.778,262.107,315.919,261.932,315.919z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M270.187,315.919c-0.174,0-0.316-0.141-0.316-0.316v-7.978c0-0.175,0.142-0.316,0.316-0.316 c0.175,0,0.316,0.141,0.316,0.316v7.978C270.503,315.778,270.362,315.919,270.187,315.919z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M278.441,315.919c-0.175,0-0.316-0.141-0.316-0.316v-7.978c0-0.175,0.142-0.316,0.316-0.316 c0.175,0,0.316,0.141,0.316,0.316v7.978C278.758,315.778,278.616,315.919,278.441,315.919z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M286.696,315.919c-0.175,0-0.316-0.141-0.316-0.316v-7.978c0-0.175,0.141-0.316,0.316-0.316 c0.175,0,0.316,0.141,0.316,0.316v7.978C287.012,315.778,286.871,315.919,286.696,315.919z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M294.951,315.919c-0.175,0-0.316-0.141-0.316-0.316v-7.978c0-0.175,0.141-0.316,0.316-0.316 c0.175,0,0.316,0.141,0.316,0.316v7.978C295.267,315.778,295.126,315.919,294.951,315.919z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M303.205,315.919c-0.175,0-0.316-0.141-0.316-0.316v-7.978c0-0.175,0.141-0.316,0.316-0.316 c0.175,0,0.316,0.141,0.316,0.316v7.978C303.522,315.778,303.381,315.919,303.205,315.919z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M311.46,315.919c-0.175,0-0.316-0.141-0.316-0.316v-7.978c0-0.175,0.141-0.316,0.316-0.316 c0.175,0,0.316,0.141,0.316,0.316v7.978C311.776,315.778,311.635,315.919,311.46,315.919z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M319.715,315.919c-0.175,0-0.316-0.141-0.316-0.316v-7.978c0-0.175,0.141-0.316,0.316-0.316 c0.175,0,0.316,0.141,0.316,0.316v7.978C320.031,315.778,319.89,315.919,319.715,315.919z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M327.969,315.919c-0.175,0-0.316-0.141-0.316-0.316v-7.978c0-0.175,0.141-0.316,0.316-0.316 c0.176,0,0.316,0.141,0.316,0.316v7.978C328.285,315.778,328.145,315.919,327.969,315.919z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M336.224,315.919c-0.175,0-0.316-0.141-0.316-0.316v-7.978c0-0.175,0.141-0.316,0.316-0.316 c0.176,0,0.316,0.141,0.316,0.316v7.978C336.54,315.778,336.399,315.919,336.224,315.919z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 234.889,
    y: 334.834,
    style: {
      fill: "#FFAE01"
    },
    width: 122.812,
    height: 15.48
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M242.52,346.879c-0.174,0-0.316-0.141-0.316-0.316v-7.978c0-0.176,0.142-0.316,0.316-0.316 c0.174,0,0.316,0.141,0.316,0.316v7.978C242.836,346.738,242.694,346.879,242.52,346.879z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M250.775,346.879c-0.174,0-0.316-0.141-0.316-0.316v-7.978c0-0.176,0.142-0.316,0.316-0.316 c0.174,0,0.316,0.141,0.316,0.316v7.978C251.091,346.738,250.949,346.879,250.775,346.879z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M259.029,346.879c-0.174,0-0.316-0.141-0.316-0.316v-7.978c0-0.176,0.142-0.316,0.316-0.316 c0.174,0,0.316,0.141,0.316,0.316v7.978C259.345,346.738,259.204,346.879,259.029,346.879z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M267.284,346.879c-0.174,0-0.316-0.141-0.316-0.316v-7.978c0-0.176,0.142-0.316,0.316-0.316 c0.175,0,0.316,0.141,0.316,0.316v7.978C267.6,346.738,267.458,346.879,267.284,346.879z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M275.539,346.879c-0.175,0-0.316-0.141-0.316-0.316v-7.978c0-0.176,0.142-0.316,0.316-0.316 c0.175,0,0.316,0.141,0.316,0.316v7.978C275.855,346.738,275.713,346.879,275.539,346.879z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M283.793,346.879c-0.175,0-0.316-0.141-0.316-0.316v-7.978c0-0.176,0.142-0.316,0.316-0.316 c0.175,0,0.316,0.141,0.316,0.316v7.978C284.109,346.738,283.968,346.879,283.793,346.879z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M292.048,346.879c-0.175,0-0.316-0.141-0.316-0.316v-7.978c0-0.176,0.141-0.316,0.316-0.316 c0.175,0,0.316,0.141,0.316,0.316v7.978C292.364,346.738,292.223,346.879,292.048,346.879z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M300.302,346.879c-0.175,0-0.316-0.141-0.316-0.316v-7.978c0-0.176,0.141-0.316,0.316-0.316 c0.175,0,0.316,0.141,0.316,0.316v7.978C300.619,346.738,300.477,346.879,300.302,346.879z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M308.557,346.879c-0.175,0-0.316-0.141-0.316-0.316v-7.978c0-0.176,0.141-0.316,0.316-0.316 c0.175,0,0.316,0.141,0.316,0.316v7.978C308.873,346.738,308.732,346.879,308.557,346.879z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M316.812,346.879c-0.175,0-0.316-0.141-0.316-0.316v-7.978c0-0.176,0.141-0.316,0.316-0.316 c0.175,0,0.316,0.141,0.316,0.316v7.978C317.128,346.738,316.987,346.879,316.812,346.879z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M325.066,346.879c-0.175,0-0.316-0.141-0.316-0.316v-7.978c0-0.176,0.141-0.316,0.316-0.316 c0.175,0,0.316,0.141,0.316,0.316v7.978C325.383,346.738,325.241,346.879,325.066,346.879z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M333.321,346.879c-0.175,0-0.316-0.141-0.316-0.316v-7.978c0-0.176,0.141-0.316,0.316-0.316 c0.175,0,0.316,0.141,0.316,0.316v7.978C333.637,346.738,333.496,346.879,333.321,346.879z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M341.576,346.879c-0.175,0-0.316-0.141-0.316-0.316v-7.978c0-0.176,0.141-0.316,0.316-0.316 c0.175,0,0.316,0.141,0.316,0.316v7.978C341.892,346.738,341.751,346.879,341.576,346.879z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M349.83,346.879c-0.176,0-0.316-0.141-0.316-0.316v-7.978c0-0.176,0.141-0.316,0.316-0.316 c0.175,0,0.316,0.141,0.316,0.316v7.978C350.146,346.738,350.005,346.879,349.83,346.879z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6D00"
    },
    d: "M319.591,273.23H216.265c-0.174,0-0.316-0.141-0.316-0.316c0-0.175,0.142-0.316,0.316-0.316 h103.326c0.176,0,0.316,0.141,0.316,0.316C319.907,273.089,319.767,273.23,319.591,273.23z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6D00"
    },
    d: "M341.069,304.19h-106.18c-0.174,0-0.316-0.141-0.316-0.316c0-0.175,0.142-0.316,0.316-0.316h106.18 c0.175,0,0.316,0.141,0.316,0.316C341.385,304.049,341.244,304.19,341.069,304.19z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6D00"
    },
    d: "M334.287,319.669h-106.18c-0.174,0-0.316-0.141-0.316-0.316s0.142-0.316,0.316-0.316h106.18 c0.176,0,0.316,0.141,0.316,0.316S334.462,319.669,334.287,319.669z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6D00"
    },
    d: "M337.879,335.151h-99.478c-0.174,0-0.316-0.141-0.316-0.316c0-0.175,0.142-0.316,0.316-0.316 h99.478c0.176,0,0.316,0.141,0.316,0.316C338.195,335.01,338.055,335.151,337.879,335.151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6D00"
    },
    d: "M346.114,350.629H238.563c-0.174,0-0.316-0.141-0.316-0.316c0-0.175,0.142-0.316,0.316-0.316 h107.551c0.176,0,0.316,0.141,0.316,0.316C346.43,350.489,346.29,350.629,346.114,350.629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6D00"
    },
    d: "M330.289,288.711h-97.956c-0.174,0-0.316-0.141-0.316-0.316c0-0.176,0.142-0.316,0.316-0.316 h97.956c0.176,0,0.316,0.141,0.316,0.316C330.605,288.57,330.465,288.711,330.289,288.711z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF827C"
    },
    d: "M159.555,336.122c-0.658,0.759-1.29,1.594-1.923,2.454c-1.847,2.505-3.593,5.414-5.212,8.475 c-3.466,6.502-6.376,13.637-8.374,18.747c0,0-37.672,4.63-53.054-7.742c5.971-12.296,27.678-3.567,43.314-16.091 c2.834-2.277,5.49-5.237,7.767-9.184c1.037-1.72,1.973-3.593,2.834-5.693L159.555,336.122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#404ADD"
    },
    d: "M152.42,347.051c-2.454,4.605-4.63,9.538-6.401,13.839c-0.734,1.771-1.391,3.415-1.973,4.908 c0,0-37.672,4.63-53.054-7.742c0.531-1.063,1.164-1.999,1.897-2.758c7.818-8.172,27.147-1.897,41.416-13.333 C138.378,345.913,147.309,347.557,152.42,347.051z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6893E6"
    },
    d: "M146.019,360.89c-0.734,1.771-1.391,3.415-1.973,4.908c0,0-37.672,4.63-53.054-7.742 c0.531-1.063,1.164-1.999,1.897-2.758C101.44,360.359,121.807,366.001,146.019,360.89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M108.382,360.216c-0.011,0-0.022,0-0.033-0.003c-0.174-0.017-0.299-0.173-0.282-0.346 c0.337-3.175-1.212-6.288-3.945-7.934c-0.149-0.091-0.198-0.287-0.107-0.435c0.089-0.151,0.284-0.198,0.434-0.109 c2.943,1.774,4.61,5.126,4.248,8.541C108.68,360.095,108.543,360.216,108.382,360.216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M108.43,354.622c-0.168,0-0.307-0.131-0.316-0.301c-0.009-0.173,0.126-0.321,0.3-0.331 c10.161-0.511,20.152-3.531,28.895-8.734c0.147-0.089,0.343-0.044,0.434,0.111c0.089,0.148,0.04,0.343-0.11,0.432 c-8.832,5.255-18.923,8.307-29.186,8.823C108.44,354.622,108.435,354.622,108.43,354.622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0D005A"
    },
    d: "M159.555,336.122c-0.658,0.759-1.29,1.594-1.923,2.454l-15.559-5.794 c1.037-1.72,1.973-3.593,2.834-5.693L159.555,336.122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF827C"
    },
    d: "M231.961,170.856c0,0-8.639-6.722-16.148-3.27c-7.509,3.452-12.293,20.65-12.293,20.65 s2.543,1.453,5.087-3.755c2.543-5.208,3.089-5.912,3.089-5.912s2.483,5.61,6.964,2.582c-0.061,4.602,1.877,7.085,4.421,6.782 c-0.908-3.27-1.696-12.85,4.481-10.422L231.961,170.856z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E43D4E"
    },
    d: "M211.514,177.829c-0.14,0-0.268-0.094-0.305-0.235c-0.4-1.502-0.31-4.368,0.461-6.08 c0.07-0.161,0.257-0.225,0.417-0.158c0.159,0.072,0.23,0.26,0.158,0.42c-0.694,1.542-0.798,4.259-0.426,5.656 c0.046,0.168-0.054,0.341-0.224,0.388C211.568,177.826,211.541,177.829,211.514,177.829z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E43D4E"
    },
    d: "M219.346,180.823c-0.096,0-0.192-0.044-0.255-0.128c-0.104-0.138-0.074-0.339,0.065-0.442 c1.497-1.112,1.991-2.229,1.695-2.713c-0.176-0.292-0.393-0.462-0.646-0.509c-0.385-0.059-0.892,0.136-1.473,0.593 c-0.754,0.59-1.707,0.719-2.488,0.331c-0.555-0.274-1.483-1.045-1.454-3.128c0.003-0.173,0.143-0.311,0.316-0.311 c0.001,0,0.003,0,0.004,0c0.176,0.003,0.315,0.146,0.313,0.321c-0.017,1.285,0.374,2.191,1.102,2.552 c0.564,0.279,1.259,0.178,1.817-0.264c0.735-0.578,1.4-0.828,1.975-0.714c0.434,0.076,0.804,0.353,1.075,0.801 c0.544,0.894-0.202,2.32-1.858,3.55C219.478,180.803,219.411,180.823,219.346,180.823z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#404ADD"
    },
    d: "M266.622,161.025l-28.1-22.923c-6.821-5.564-7.127-15.881-0.649-21.84l21.683-19.945l12.758,19.58 l-7.78,7.326c-3.015,2.839-2.728,7.714,0.599,10.18l10.249,7.597L266.622,161.025z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF827C"
    },
    d: "M283.879,80.745c1.88-2.846,4.259-4.239,5.976-3.452c1.717,0.787,0,2.995,0,2.995 s2.08-3.152,4.624-1.378c2.544,1.774-0.363,4.56-0.363,4.56s2.725-2.907,4.481-1.332c1.756,1.574,0,3.836,0,3.836 s2.604-0.687,3.452,1.554c0.848,2.241-2.737,5.172-2.737,5.172L286.965,90L283.879,80.745z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6893E6"
    },
    d: "M260.687,153.635c-0.062,0-0.123-0.017-0.178-0.054c-0.146-0.099-0.183-0.296-0.084-0.44 c1.097-1.596,2.11-5.569,0.934-9.408c-1.028-3.36-3.444-5.811-7.182-7.284c-4.084-1.608-6.35-3.437-6.923-5.594 c-0.734-2.745,1.354-5.665,3.751-8.665c1.544-1.935,3.963-5.591,2.804-8.354c-0.803-1.907-3.184-3.073-7.081-3.469 c-0.173-0.018-0.299-0.173-0.282-0.346c0.015-0.173,0.173-0.318,0.346-0.282c4.143,0.42,6.7,1.715,7.6,3.849 c0.954,2.273-0.074,5.465-2.893,8.996c-2.29,2.868-4.292,5.645-3.635,8.106c0.519,1.949,2.661,3.639,6.545,5.169 c3.871,1.525,6.483,4.183,7.555,7.686c1.238,4.04,0.151,8.252-1.016,9.949C260.887,153.589,260.788,153.635,260.687,153.635z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0D005A"
    },
    d: "M261.969,103.463c-5.319-1.381-7.095-6.468-4.996-10.101c2.099-3.634,5.369-4.037,7.893-2.423 c-1.352-9.044,8.822-13.242,14.716-7.59c1.292-5.006,11.466-4.441,11.708,5.975c8.11-3.902,18.249,10.335,5.142,24.265 c-1.549,1.646-2.364,3.852-2.161,6.102c0.311,3.457,0.815,7.865,0.815,7.865l-14.444-15.822L261.969,103.463z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF827C"
    },
    d: "M280.792,129.598l1.341-3.618l-0.152,0.101c-0.734,0.405-3.896,2.15-7.818,2.935 c-1.898,0.405-3.82-0.506-4.731-2.226c-3.972-7.565-6.932-16.673-7.464-23.327c2.404,0.708,8.4-0.683,10.171-4.554 c0.354,2.125,4.174,4.605,7.084,0.911c-0.784,5.035,4.529,8.855,4.529,8.855s4.427-6.502,7.388-1.948 c2.985,4.529-0.885,7.514-0.885,7.514l9.057,18.646h-19.734L280.792,129.598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0D005A"
    },
    d: "M266.622,108.859c-0.025,0-0.052-0.003-0.079-0.01c-0.168-0.042-0.269-0.215-0.227-0.386 c0.539-2.117,2.275-3.756,4.425-4.17c0.166-0.025,0.338,0.081,0.371,0.252c0.032,0.171-0.079,0.336-0.252,0.371 c-1.91,0.368-3.452,1.821-3.931,3.706C266.891,108.762,266.763,108.859,266.622,108.859z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0D005A"
    },
    d: "M285.335,112.491c-0.035,0-0.072-0.005-0.106-0.017c-0.165-0.06-0.249-0.24-0.193-0.405 c0.642-1.799,1.816-3.318,3.39-4.395c0.143-0.099,0.339-0.064,0.44,0.084c0.099,0.143,0.062,0.341-0.084,0.44 c-1.463,1.001-2.552,2.414-3.148,4.084C285.587,112.409,285.466,112.491,285.335,112.491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF827C"
    },
    d: "M264.745,110.661c-1.985,1.827-2.747,4.851-3.036,6.717c-0.145,0.938,0.575,1.774,1.524,1.801 c1.314,0.038,3.25-0.084,5.293-0.827L264.745,110.661z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E43D4E"
    },
    d: "M272.315,121.864c1.717-1.014,2.959-2.67,3.452-4.603c1.2,0.975,1.416,2.725,0.488,3.962 C275.327,122.461,273.587,122.744,272.315,121.864z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M273.177,112.267c-0.177,0.202-0.354,0.405-0.557,0.557c-1.316,1.189-3.061,1.796-4.858,1.645 c-0.101-2.1,0.658-4.048,1.999-5.49c1.214-1.316,2.91-2.226,4.807-2.404C275.049,108.574,274.518,110.699,273.177,112.267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0D005A"
    },
    d: "M272.62,112.824c-1.316,1.189-3.061,1.796-4.858,1.645c-0.101-2.1,0.658-4.048,1.999-5.49 C271.355,109.611,272.494,111.078,272.62,112.824z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0D005A"
    },
    d: "M286.965,122.387c0,0-0.278,4.453-6.173,7.21l1.341-3.618 C284.663,124.588,286.965,122.387,286.965,122.387z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#404ADD"
    },
    d: "M263.41,95.507c-1.09,0-2.09-0.321-3.024-0.62c-0.961-0.311-1.868-0.595-2.752-0.504 c-0.163,0.052-0.329-0.104-0.348-0.279c-0.02-0.173,0.106-0.328,0.279-0.348c1.006-0.121,1.984,0.198,3.014,0.529 c1.771,0.568,3.597,1.159,5.858-0.472c1.722-1.243,2.014-3.288,2.32-5.453c0.442-3.103,0.899-6.315,5.771-7.019 c0.165-0.039,0.331,0.096,0.358,0.269c0.025,0.173-0.096,0.333-0.269,0.358c-4.403,0.635-4.806,3.474-5.233,6.481 c-0.314,2.201-0.635,4.477-2.577,5.878C265.577,95.213,264.453,95.507,263.41,95.507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#404ADD"
    },
    d: "M294.538,114.806c-0.114,0-0.222-0.062-0.279-0.171c-0.042-0.082-1.008-2.095,1.688-8.188 c1.146-2.592,1.129-4.773-0.049-6.142c-1.082-1.26-3.076-1.673-5.211-1.092c-4.776,1.302-7.956,0.111-10.318-3.864 c-0.793-1.334-1.804-2.102-3.002-2.288c-1.883-0.291-4.274,0.833-6.97,3.239c-4.398,3.931-8.124,5.317-11.726,4.373 c-0.171-0.045-0.272-0.217-0.227-0.385c0.045-0.171,0.235-0.267,0.385-0.228c3.392,0.892,6.925-0.457,11.148-4.23 c2.878-2.572,5.401-3.701,7.486-3.395c1.393,0.215,2.555,1.085,3.449,2.592c2.219,3.736,5.097,4.798,9.606,3.577 c2.389-0.652,4.62-0.153,5.858,1.287c1.347,1.564,1.399,3.983,0.148,6.812c-2.537,5.732-1.71,7.63-1.7,7.649 c0.074,0.156,0.01,0.344-0.146,0.42C294.632,114.796,294.585,114.806,294.538,114.806z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#404ADD"
    },
    d: "M289.409,96.629c-1.235,0-2.518-0.462-3.812-1.729c-2.209-2.164-1.339-4.803-0.499-7.355 c0.749-2.268,1.453-4.41-0.002-6.11c-0.114-0.131-0.099-0.331,0.034-0.445c0.131-0.116,0.329-0.101,0.445,0.035 c1.688,1.969,0.894,4.383,0.123,6.718c-0.815,2.478-1.586,4.818,0.344,6.708c2.878,2.824,5.566,1.238,8.163-0.297 c1.638-0.966,3.195-1.9,4.618-1.448c0.89,0.272,1.621,1.04,2.241,2.347c0.074,0.158,0.007,0.348-0.151,0.423 c-0.165,0.069-0.348,0.005-0.422-0.15c-0.536-1.139-1.144-1.799-1.853-2.016c-1.161-0.356-2.592,0.494-4.111,1.391 C293.004,95.596,291.257,96.629,289.409,96.629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#404ADD"
    },
    d: "M279.306,88.11c-0.03,0-0.059-0.003-0.089-0.003c-0.539-0.022-0.956-0.321-1.139-0.823 c-0.291-0.781,0.01-2.125,1.337-3.36l0.274-0.255l0.205,0.314c0.939,1.431,1.216,2.641,0.781,3.41 C280.416,87.851,279.922,88.11,279.306,88.11z M279.573,84.661c-0.879,0.944-1.094,1.888-0.902,2.404 c0.096,0.262,0.289,0.398,0.571,0.41c0.262-0.007,0.677-0.032,0.882-0.393C280.26,86.842,280.46,86.143,279.573,84.661z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#404ADD"
    },
    d: "M289.809,93.629c-0.264,0-0.546-0.072-0.825-0.215c-0.482-0.247-0.732-0.692-0.692-1.226 c0.067-0.83,0.902-1.922,2.622-2.491l0.356-0.116l0.057,0.371c0.252,1.693-0.005,2.908-0.721,3.424 C290.37,93.545,290.098,93.629,289.809,93.629z M290.751,90.435c-1.193,0.489-1.784,1.255-1.826,1.804 c-0.022,0.277,0.094,0.484,0.346,0.613c0.212,0.111,0.625,0.26,0.963,0.012C290.459,92.703,290.934,92.152,290.751,90.435z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0D005A"
    },
    d: "M263.647,119.5c-0.148,0-0.289-0.002-0.425-0.005c-0.548-0.015-1.065-0.264-1.416-0.684 c-0.341-0.41-0.492-0.951-0.413-1.48c0.272-1.749,1.04-4.971,3.135-6.903c0.128-0.121,0.328-0.114,0.447,0.017 c0.119,0.129,0.111,0.329-0.017,0.447c-1.954,1.801-2.681,4.867-2.94,6.535c-0.052,0.353,0.044,0.702,0.274,0.978 c0.234,0.279,0.578,0.447,0.949,0.457c1.26,0.049,3.167-0.077,5.176-0.808c0.163-0.069,0.343,0.022,0.405,0.188 c0.06,0.166-0.024,0.346-0.188,0.405C266.745,119.337,264.942,119.5,263.647,119.5z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#404ADD"
    },
    d: "M302.351,143.779v-7.601c0-2.242-1.817-4.059-4.059-4.059h-21.967 c-2.242,0-4.059,1.817-4.059,4.059v9.165c-7.19,8.523-11.325,19.221-11.793,30.423c-3.031-1.613-6.316-2.746-9.746-3.273 c-2.822-0.434-5.643-0.021-8.163,1.088l-8.125-4.691c-1.081-0.624-2.462-0.254-3.086,0.827l-5.456,9.449 c-0.624,1.081-0.253,2.462,0.827,3.086l6.889,3.977c-0.309,3.785,0.779,7.633,3.378,10.636 c6.574,7.593,18.322,14.137,29.064,16.805c0.165,0.041,0.34,0.067,0.507,0.105l-0.507,2.802l38.475,10.658 c4.913-19.226,6.807-43.43,4.694-58.519l1.039-2.745C313.575,157.222,309.689,148.044,302.351,143.779z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6893E6"
    },
    d: "M304.703,213.296c-5.705,0-6.824-3.207-8.223-7.207c-1.231-3.518-2.624-7.508-7.504-10.683 c-5.05-3.281-11.2-0.195-17.149,2.797c-6.523,3.271-13.26,6.661-18.046,0.895c-4.805-5.796-2.449-11.148-0.553-15.449 c1.712-3.891,3.066-6.965-0.59-9.436c-0.143-0.099-0.183-0.294-0.084-0.44c0.099-0.143,0.294-0.18,0.44-0.084 c4.092,2.767,2.5,6.384,0.813,10.214c-1.92,4.358-4.094,9.297,0.464,14.79c4.462,5.386,10.686,2.253,17.273-1.055 c6.108-3.073,12.428-6.246,17.779-2.76c5.06,3.291,6.555,7.568,7.755,11.005c1.448,4.138,2.505,7.14,8.645,6.747 c0.175,0.007,0.326,0.121,0.336,0.296c0.01,0.175-0.124,0.324-0.297,0.336C305.392,213.283,305.039,213.296,304.703,213.296z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6893E6"
    },
    d: "M298.113,191.773c-0.101,0-0.2-0.049-0.262-0.138c-1.863-2.73-2.594-8.862,0.21-15.872 c1.497-3.743,1.178-7.41-0.779-8.912c-2.066-1.593-5.576-0.704-9.883,2.503c-6.552,4.875-9.962,3.837-11.41,2.785 c-2.078-1.512-2.638-4.788-1.431-8.349c1.487-4.39,1.455-7.758-0.091-9.24c-1.3-1.248-3.659-1.221-7.007,0.069 c-0.16,0.067-0.348-0.017-0.408-0.18c-0.064-0.163,0.017-0.346,0.18-0.408c3.6-1.394,6.177-1.371,7.672,0.062 c2.372,2.273,1.176,7.177,0.252,9.9c-1.117,3.291-0.645,6.288,1.206,7.634c2.221,1.623,6.11,0.605,10.661-2.782 c6.142-4.571,9.305-3.531,10.644-2.495c2.214,1.702,2.607,5.579,0.981,9.651c-2.903,7.254-1.754,13.112-0.274,15.279 c0.099,0.143,0.062,0.341-0.084,0.44C298.237,191.756,298.175,191.773,298.113,191.773z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M273.767,190.249c-0.007,0-0.012,0-0.02,0c-0.136-0.01-0.249-0.101-0.284-0.232 c-0.914-3.315-8.391-10.421-11.993-13.031c-0.141-0.104-0.173-0.301-0.072-0.442c0.099-0.143,0.297-0.175,0.443-0.072 c2.982,2.162,10.172,8.712,11.941,12.598l13.987-33.656c0.064-0.16,0.252-0.242,0.413-0.17c0.161,0.066,0.237,0.252,0.171,0.412 l-14.293,34.397C274.009,190.172,273.893,190.249,273.767,190.249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6893E6"
    },
    d: "M239.25,176.198c-0.053,0-0.107-0.012-0.157-0.042l-6.783-3.874 c-0.152-0.086-0.204-0.279-0.117-0.43c0.084-0.156,0.278-0.212,0.431-0.119l6.783,3.874c0.152,0.086,0.204,0.279,0.117,0.43 C239.466,176.141,239.36,176.198,239.25,176.198z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6893E6"
    },
    d: "M237.317,179.627c-0.053,0-0.108-0.012-0.157-0.042l-6.783-3.877 c-0.152-0.087-0.204-0.279-0.117-0.432c0.087-0.15,0.278-0.207,0.431-0.116l6.783,3.877c0.152,0.086,0.204,0.279,0.117,0.432 C237.533,179.57,237.427,179.627,237.317,179.627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6893E6"
    },
    d: "M235.352,182.762c-0.053,0-0.108-0.012-0.157-0.042l-6.782-3.876 c-0.152-0.087-0.204-0.279-0.117-0.432c0.085-0.153,0.277-0.21,0.431-0.116l6.782,3.876c0.152,0.087,0.204,0.279,0.117,0.432 C235.569,182.706,235.462,182.762,235.352,182.762z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6893E6"
    },
    d: "M276.809,143.014c-0.012,0-0.025,0-0.037-0.003c-0.173-0.02-0.299-0.178-0.277-0.351l0.862-7.187 c0.022-0.173,0.185-0.306,0.351-0.277c0.173,0.02,0.299,0.178,0.277,0.351l-0.862,7.187 C277.103,142.895,276.967,143.014,276.809,143.014z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6893E6"
    },
    d: "M283.324,143.014c-0.012,0-0.025,0-0.037-0.003c-0.173-0.02-0.296-0.178-0.277-0.351l0.86-7.187 c0.022-0.173,0.183-0.306,0.351-0.277c0.173,0.02,0.296,0.178,0.276,0.351l-0.86,7.187 C283.618,142.895,283.482,143.014,283.324,143.014z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6893E6"
    },
    d: "M289.836,143.014c-0.012,0-0.025,0-0.037-0.003c-0.173-0.02-0.296-0.178-0.276-0.351l0.86-7.187 c0.022-0.173,0.183-0.306,0.351-0.277c0.173,0.02,0.297,0.178,0.277,0.351l-0.86,7.187 C290.13,142.895,289.995,143.014,289.836,143.014z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6893E6"
    },
    d: "M296.349,143.014c-0.012,0-0.025,0-0.037-0.003c-0.173-0.02-0.299-0.178-0.277-0.351l0.862-7.187 c0.022-0.173,0.18-0.306,0.351-0.277c0.173,0.02,0.299,0.178,0.277,0.351l-0.862,7.187 C296.643,142.895,296.507,143.014,296.349,143.014z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M304.29,219.195c-0.025,0-0.052-0.003-0.079-0.01l-18.834-4.845 c-0.168-0.044-0.272-0.215-0.227-0.386c0.045-0.168,0.203-0.281,0.386-0.227l18.834,4.845c0.168,0.044,0.272,0.215,0.227,0.386 C304.559,219.102,304.431,219.195,304.29,219.195z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0D005A"
    },
    d: "M291.367,208.964c2.581-2.353,4.655-5.338,5.945-8.754l9.943-26.261 C306.702,190.579,304.043,202.31,291.367,208.964z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M276.225,215.109c-0.114,0-0.225,0-0.339-0.003c-2.701-0.037-5.196-0.245-7.412-0.615 c-0.173-0.027-0.289-0.19-0.259-0.363c0.027-0.173,0.19-0.279,0.363-0.26c2.187,0.363,4.648,0.568,7.318,0.605 c0.109,0.003,0.218,0.003,0.329,0.003c9.196,0,17.52-5.74,20.783-14.367l10.807-28.561c0.064-0.163,0.242-0.245,0.408-0.185 c0.163,0.062,0.247,0.244,0.185,0.408l-10.807,28.561C294.244,209.207,285.681,215.109,276.225,215.109z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M203.435,118.525c-10.842,0-19.631,8.789-19.631,19.631c0,3.079,0.729,5.982,1.993,8.576 l-8.029,9.219l11.885-3.824c3.545,3.497,8.409,5.66,13.782,5.66c10.842,0,19.631-8.789,19.631-19.631 C223.066,127.313,214.277,118.525,203.435,118.525z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6893E6"
    },
    d: "M203.435,158.102c-5.206,0-10.123-1.994-13.867-5.618l-12.785,4.116l8.639-9.92 c-1.283-2.703-1.935-5.569-1.935-8.526c0-10.997,8.949-19.946,19.947-19.946c10.998,0,19.947,8.949,19.947,19.946 C223.382,149.154,214.433,158.102,203.435,158.102z M189.738,151.765l0.137,0.136c3.641,3.59,8.456,5.569,13.559,5.569 c10.65,0,19.315-8.665,19.315-19.316c0-10.649-8.665-19.313-19.315-19.313c-10.65,0-19.315,8.665-19.315,19.313 c0,2.928,0.66,5.767,1.962,8.437l0.092,0.188l-7.421,8.521L189.738,151.765z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6D00"
    },
    d: "M212.594,141.353c-1.678,4.937-7.041,7.579-11.978,5.902c-4.937-1.678-7.58-7.04-5.902-11.978 c1.678-4.937,7.04-7.579,11.978-5.901S214.271,136.416,212.594,141.353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAE01"
    },
    d: "M213.317,141.599c-1.678,4.937-7.041,7.58-11.978,5.902c-4.937-1.678-7.58-7.04-5.902-11.978 c1.678-4.937,7.041-7.58,11.978-5.902C212.352,131.299,214.995,136.662,213.317,141.599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M208.749,136.767h-3.116c-0.017-0.707-0.741-0.859-1.196-0.859c-0.286,0-1.212,0-1.212,0.573 c0,1.28,5.744-0.051,5.744,3.571c0,2.173-1.701,2.982-3.79,3.133l0.134,2.308h-1.903l0.118-2.325 c-1.937-0.202-3.74-1.112-3.74-3.065h3.117v0.067c0.016,0.859,0.977,1.027,1.466,1.027c0.472,0,1.398-0.034,1.398-0.657 c0-1.331-5.744-0.118-5.744-3.622c0-2.021,1.566-2.796,3.504-2.965l-0.118-2.324h1.903l-0.134,2.308 C207.047,134.088,208.749,134.897,208.749,136.767z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#404ADD"
    },
    d: "M231.615,195.073h-38.806v4.411h38.806c1.218,0,2.205-0.987,2.205-2.205 C233.821,196.06,232.833,195.073,231.615,195.073z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#404ADD"
    },
    points: "165.649,155.609 130.983,155.609 163.25,199.484 197.916,199.484  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M166.569,175.582c3.203,4.598,4.273,8.326,2.389,8.326c-1.885,0-6.009-3.728-9.213-8.326 c-3.204-4.598-4.273-8.326-2.389-8.326C159.241,167.256,163.365,170.983,166.569,175.582z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E43D4E"
    },
    d: "M304.523,227.23c0,0-2.1,15.079-13.156,30.385l-80.252-0.177c0,0-15.433,27.071-31.499,65.375 c-1.569,3.744-3.163,7.615-4.731,11.562c-1.063,2.682-2.125,5.414-3.188,8.197c0,0-27.779-9.715-40.531-24.415 c0,0,14.117-54.952,41.34-93.332c4.68-6.603,12.018-10.803,20.088-11.537c15.458-1.467,43.592-2.631,73.471,3.289L304.523,227.23z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0D005A"
    },
    d: "M179.617,322.814c-1.569,3.744-3.163,7.615-4.731,11.562c-3.542-9.108-10.55-34.889-11.41-53.712 L179.617,322.814z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAE01"
    },
    d: "M146.911,323.106c-0.02,0-0.04-0.003-0.059-0.005c-0.172-0.034-0.284-0.2-0.251-0.37 c1.458-7.605,6.591-28.749,22.723-60.757c19.775-39.222,56.399-27.558,74.006-21.947l0.981,0.311 c17.769,5.648,38.835,3.101,45.834-15.311c0.064-0.165,0.244-0.242,0.41-0.185c0.163,0.062,0.244,0.245,0.183,0.408 c-7.152,18.802-28.566,21.421-46.619,15.691l-0.981-0.311c-17.435-5.557-53.716-17.12-73.248,21.631 c-16.098,31.934-21.214,53.011-22.669,60.589C147.193,323,147.061,323.106,146.911,323.106z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0D005A"
    },
    d: "M237.316,214.794c-11.197,1.979-18.64,6.306-25.036,11.796c1.525,9.804,3.113,20.975,2.095,30.845 h-5.163l-7.388-36.739L237.316,214.794z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E43D4E"
    },
    d: "M207.144,225.131c8.349,31.549,13.08,63.958,14.143,96.57 c-12.448,7.843-27.375,10.727-41.821,8.071c-17.331-35.091-22.719-74.837-15.408-113.192c0.961-4.959,3.415-9.589,7.388-12.726 c0.051-0.025,0.076-0.076,0.127-0.101c3.213-2.505,7.21-3.871,11.284-4.073c24.389-1.189,48.677,3.896,70.562,14.775 C237.251,212.987,221.033,216.731,207.144,225.131z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0D005A"
    },
    d: "M221.286,321.701c-12.448,7.843-27.375,10.727-41.821,8.071 C191.559,321.119,206.84,318.184,221.286,321.701z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAE01"
    },
    d: "M200.632,314.567c-0.003,0-0.005,0-0.007,0c-0.176-0.005-0.313-0.148-0.309-0.324 c0.725-29.28-3.474-58.259-12.482-86.134c-1.248-3.861-0.741-8.074,1.39-11.56c2.137-3.494,5.67-5.87,9.693-6.52 c15.453-2.498,31-1.905,46.213,1.769c0.171,0.04,0.274,0.21,0.232,0.381c-0.04,0.173-0.205,0.284-0.381,0.232 c-15.133-3.652-30.6-4.24-45.964-1.759c-3.841,0.623-7.215,2.893-9.254,6.229c-2.035,3.325-2.519,7.348-1.327,11.037 c9.029,27.941,13.239,56.991,12.512,86.341C200.943,314.431,200.804,314.567,200.632,314.567z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF827C"
    },
    d: "M213.621,344.951c-4.25,7.919-22.315,28.184-36.128,25.325c-2.15-0.43-3.744-2.277-3.896-4.453 c-0.961-12.827,16.749-16.749,19.43-27.248c0.152-0.582,0.278-1.139,0.38-1.67c1.645-7.818,0.202-13.181,0.202-13.181 s5.692-2.758,15.155-2.707c0.177,1.923,0.43,4.352,0.784,6.932C210.357,334.098,211.673,341.207,213.621,344.951z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#404ADD"
    },
    d: "M213.621,344.951c-4.25,7.919-22.315,28.184-36.128,25.325c-2.15-0.43-3.744-2.277-3.896-4.453 c-0.076-0.86-0.051-1.67,0.076-2.429c1.265-10.93,16.85-15.028,19.354-24.819c0.152-0.582,0.278-1.139,0.38-1.67 c4.174-0.152,13.257-2.53,16.141-8.956c0.582,4.427,1.417,9.336,2.581,13.156C212.583,342.599,213.089,343.889,213.621,344.951z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6893E6"
    },
    d: "M213.621,344.951c-4.25,7.919-22.315,28.184-36.128,25.325c-2.15-0.43-3.744-2.277-3.896-4.453 c-0.076-0.86-0.051-1.67,0.076-2.429c0.81,4.655,7.565,4.529,14.674,0.936c6.983-3.542,19.203-14.674,23.782-23.225 C212.583,342.599,213.089,343.889,213.621,344.951z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M188.098,363.606c-0.153,0-0.287-0.111-0.313-0.267c-0.71-4.388-4.625-7.496-9.033-7.195 c-0.193,0.003-0.326-0.121-0.336-0.297c-0.012-0.173,0.12-0.324,0.294-0.336c0.206-0.012,0.41-0.02,0.613-0.02 c4.508,0,8.357,3.237,9.087,7.748c0.027,0.171-0.09,0.333-0.262,0.36C188.131,363.603,188.114,363.606,188.098,363.606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M184.303,356.124c-0.073,0-0.147-0.025-0.206-0.077c-0.132-0.114-0.147-0.314-0.033-0.447 c2.719-3.15,5.399-5.574,7.763-7.711c4.326-3.911,7.452-6.738,7.583-11.094c0.005-0.171,0.146-0.306,0.316-0.306 c0.002,0,0.006,0,0.01,0c0.174,0.005,0.311,0.151,0.306,0.326c-0.138,4.625-3.349,7.526-7.791,11.543 c-2.351,2.125-5.014,4.534-7.707,7.657C184.48,356.087,184.392,356.124,184.303,356.124z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0D005A"
    },
    d: "M169.769,311.931c-0.14,0-0.267-0.091-0.305-0.232c-4.539-16.564-9.053-42.852-8.895-61.049 c0.001-0.173,0.144-0.314,0.316-0.314c0.001,0,0.001,0,0.003,0c0.175,0.003,0.315,0.143,0.314,0.319 c-0.157,18.14,4.345,44.356,8.872,60.876c0.046,0.168-0.053,0.343-0.221,0.388C169.824,311.928,169.796,311.931,169.769,311.931z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0D005A"
    },
    d: "M290.892,223.774c-0.027,0-0.057-0.003-0.084-0.012l-24.836-6.881 c-0.168-0.047-0.267-0.22-0.22-0.388c0.044-0.168,0.225-0.277,0.388-0.22l24.835,6.881c0.168,0.047,0.267,0.22,0.22,0.388 C291.158,223.682,291.03,223.774,290.892,223.774z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0D005A"
    },
    d: "M264.724,157.749c-0.039,0-0.081-0.007-0.121-0.025c-0.161-0.067-0.237-0.252-0.171-0.413 c0.333-0.808,3.36-7.958,7.516-12.099v-4.334c0-0.175,0.141-0.316,0.316-0.316c0.175,0,0.316,0.141,0.316,0.316v4.465 c0,0.084-0.035,0.165-0.094,0.225c-4.114,4.04-7.14,11.185-7.472,11.985C264.966,157.675,264.848,157.749,264.724,157.749z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAE01"
    },
    d: "M171.061,337.688c-0.031,0-0.062-0.005-0.093-0.015c-13.658-4.2-26.323-11.654-36.623-21.552 c-0.126-0.121-0.131-0.321-0.01-0.447c0.123-0.123,0.324-0.126,0.447-0.007c10.231,9.828,22.807,17.231,36.371,21.404 c0.167,0.05,0.261,0.228,0.21,0.396C171.322,337.602,171.197,337.688,171.061,337.688z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAE01"
    },
    d: "M180.428,324.929c-0.1,0-0.2-0.047-0.261-0.138c-0.099-0.143-0.062-0.341,0.082-0.44 c11.473-7.864,25.749-10.296,39.18-6.663c0.168,0.047,0.268,0.22,0.222,0.388c-0.046,0.168-0.211,0.274-0.388,0.225 c-13.247-3.588-27.337-1.191-38.657,6.574C180.552,324.912,180.489,324.929,180.428,324.929z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0D005A"
    },
    d: "M217.146,221.315c-0.116,0-0.227-0.064-0.283-0.175c-0.078-0.156-0.015-0.346,0.141-0.423 c3.361-1.685,14.935-6.931,28.53-6.931c0.769,0,1.544,0.017,2.328,0.052c0.173,0.007,0.309,0.156,0.301,0.331 c-0.007,0.173-0.165,0.306-0.331,0.301c-0.771-0.035-1.539-0.052-2.3-0.052c-13.454,0-24.916,5.193-28.244,6.861 C217.242,221.305,217.194,221.315,217.146,221.315z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.af8cf3d60c256c84f5f2c7121978be41.svg";
export { ForwardRef as ReactComponent };